const KeyBindings = {
    FORWARD: "KeyW",
    BACK: "KeyS",
    LEFT: "KeyA",
    RIGHT: "KeyD",
    RUN: "ShiftLeft",
    JUMP: "Space",
    DRAW_PRIMARY_WEAPON: "Digit1",
    DRAW_SECONDARY_WEAPON: "Digit2",
    TOGGLE_FIRING_MODE: "KeyT",
    TOGGLE_DEBUG_OVERLAY: "Backquote",
    SWITCH_CAMERA: "KeyQ",
};
const MouseCodes = {
    LEFT: 0,
    RIGHT: 2,
};
export { KeyBindings, MouseCodes };
